import { formatWithHoursMinutes } from 'shared/time-utilites'
import isMobile from 'shared/responsive-helpers'
import { TableRow, TableCell } from '@components/Table'

import Price from './Price'

const calculateBalance = (total, spent) => (total >= 0 && spent >= 0 && total >= spent ? total - spent : undefined)

const Promotion = ({ promotion: { couponCode, totalSum, spentSum, currencyCode, expiryDate } }) => {
    const textAreaRef = React.useRef(null)
    const [isCodeCopied, setCodeCopied] = React.useState(false)
    const [isTooltipVisible, setTooltipVisible] = React.useState(false)

    const copyToClipboard = () => {
        const { current } = textAreaRef
        if (current == null) return
        current.select()

        if (document.execCommand('copy')) {
            document.execCommand('copy')
            setCodeCopied(true)
        }
    }

    React.useEffect(() => {
        if (isCodeCopied) {
            setTooltipVisible(true)
        }

        const timeout = setTimeout(() => {
            setTooltipVisible(false)
        }, 1500)

        return () => {
            clearTimeout(timeout)
            setTooltipVisible(false)
        }
    }, [isCodeCopied])

    React.useEffect(() => {
        if (!isTooltipVisible) {
            setCodeCopied(false)
        }
    }, [isTooltipVisible])

    return (
        <TableRow>
            <TableCell
                className="table__cell__m"
                title={<T>dashboard.promotions.promo.code</T>}
                text={couponCode}
                textClass="emphasised"
                hasIconBtn={isMobile()}
                icon="copy-code"
                iconBtnClass="icon-copy"
                allowCopy={true}
                textAreaRef={textAreaRef}
                isTooltipVisible={isTooltipVisible}
                tooltipText={<T>dashboard.promotions.promo.copy.success</T>}
                onIconClick={copyToClipboard}
            />
            {!isMobile() && (
                <TableCell
                    className="table__cell__s center"
                    hasIconBtn={true}
                    icon="copy-code"
                    iconBtnClass="icon-copy"
                    isTooltipVisible={isTooltipVisible}
                    tooltipText={<T>dashboard.promotions.promo.copy.success</T>}
                    onIconClick={copyToClipboard}
                />
            )}
            <TableCell className="table__cell__s" title={<T>dashboard.promotions.promo.sum</T>}>
                <Price className="table__cell__text" value={totalSum} currency={currencyCode} style="currency" />
            </TableCell>
            <TableCell className="table__cell__s" title={<T>dashboard.promotions.promo.spent</T>}>
                <Price className="table__cell__text" value={spentSum} currency={currencyCode} style="currency" />
            </TableCell>
            <TableCell
                className="table__cell__m"
                title={<T>dashboard.promotions.promo.expiryDate</T>}
                text={formatWithHoursMinutes(expiryDate)}
            />
            {!isMobile() && <TableCell className="table__cell__l" />}
            <TableCell className="table__cell__xs emphasised" title={<T>dashboard.promotions.promo.balance</T>}>
                <Price
                    className="table__cell__text"
                    value={calculateBalance(totalSum, spentSum)}
                    currency={currencyCode}
                    style="currency"
                />
            </TableCell>
        </TableRow>
    )
}

Promotion.propTypes = {
    couponCode: PropTypes.string,
    totalSum: PropTypes.number,
    spentSum: PropTypes.number,
    currencyCode: PropTypes.string,
    expiryDate: PropTypes.shape({}),
}

export default Promotion
